import "./searchbar.css";
import React, { useState, useEffect } from "react";
import API from "../../API";
import { useTranslation } from 'react-i18next'; // Import useTranslation

export default function Searchbar({ onSearch, initialParams = {} }) {
  const { t } = useTranslation(); // Use the useTranslation hook

  const [searchParams, setSearchParams] = useState({
    location: initialParams.location || "",
    hotelCategory: initialParams.hotelCategory || "",
    priceMin: initialParams.priceMin || "",
    priceMax: initialParams.priceMax || "",
  });

  const [locationOptions, setLocationOptions] = useState([]);
  const [titleOptions, setTitleOptions] = useState([]);

  // Fetch unique locations and titles for dropdown
  useEffect(() => {
    const fetchSearchOptions = async () => {
      try {
        const response = await API.get("/voyage-organize");
        const uniqueLocations = [
          ...new Set(
            response.data
              .map((voyage) => voyage.cite?.trim())
              .filter((cite) => cite && cite !== "")
          ),
        ];
        const uniqueTitles = [
          ...new Set(
            response.data
              .map((voyage) => voyage.title?.trim())
              .filter((title) => title && title !== "")
          ),
        ];
        setLocationOptions(uniqueLocations);
        setTitleOptions(uniqueTitles);
      } catch (error) {
        console.error("Error fetching search options:", error);
        setLocationOptions([]);
        setTitleOptions([]);
      }
    };
    fetchSearchOptions();
  }, []);

  const handleInputChange = (field, value) => {
    const updatedParams = {
      ...searchParams,
      [field]: value,
    };

    setSearchParams(updatedParams);

    // Trigger search immediately after input change
    if (onSearch) {
      const searchData = {
        ...updatedParams,
        priceMin: updatedParams.priceMin ? Number(updatedParams.priceMin) : undefined,
        priceMax: updatedParams.priceMax ? Number(updatedParams.priceMax) : undefined,
      };
      onSearch(searchData);
    }
  };

  return (
    <div className="Searchbar">
      <div className="container">
        <p className="title">{t("searchbar.title")}</p> {/* Translated text */}
        <div className="row">
          <p className="text">{t("searchbar.text")}</p> {/* Translated text */}

          {/* Location Input */}
          <div className="input-container">
            <input
              type="text"
              placeholder={t("searchbar.locationPlaceholder")}
              value={searchParams.location}
              onChange={(e) => handleInputChange("location", e.target.value)}
              list="location-options"
            />
            <datalist id="location-options">
              {locationOptions.map((loc, index) => (
                <option key={index} value={loc} />
              ))}
            </datalist>
          </div>

          {/* Hotel Category Input */}
          <div className="input-container">
            <input
              type="text"
              placeholder={t("searchbar.titlePlaceholder")} 
              value={searchParams.hotelCategory}
              onChange={(e) => handleInputChange("hotelCategory", e.target.value)}
              list="title-options"
            />
            <datalist id="title-options">
              {titleOptions.map((title, index) => (
                <option key={index} value={title} />
              ))}
            </datalist>
          </div>

          {/* Price Min Input */}
          <div className="input-container">
            <input
              type="number"
              placeholder={t("searchbar.priceMinPlaceholder")} 
              value={searchParams.priceMin}
              onChange={(e) => handleInputChange("priceMin", e.target.value)}
              min="0"
            />
          </div>

          {/* Price Max Input */}
          <div className="input-container">
            <input
              type="number"
              placeholder={t("searchbar.priceMaxPlaceholder")} 
              value={searchParams.priceMax}
              onChange={(e) => handleInputChange("priceMax", e.target.value)}
              min="0"
            />
          </div>
        </div>
      </div>
    </div>
  );
}